module.exports = __webpack_public_path__ + "img/4.1f507dc0.jpg";